











import Vue from 'vue';
import UploadExcel from 'common/components/ui/UploadExcel/index.vue';

export default Vue.extend({
  components: {
    UploadExcel,
  },
  data() {
    return {
      uploadUrl: 'api-crm-web/customer/uploadFieldExcel',
    };
  },
  methods: {
    afterUpload(result: any) {
      const fields = result.fields.filter((f: string) => f && f.trim() !== '');
      if (!fields || fields.length < 1) {
        this.$Message.warning('上传的文件格式不正确');
      } else {
        this.$store.commit('SET_CUSTOMER_IMPORT', {
          excelUrl: result.url,
          total: result.total,
          columns: fields,
        });
      }
    },
  },
});
